// extracted by mini-css-extract-plugin
module.exports = {"container":"_2npxLXgo-eVkvBlgdqR_M3","cancelBtn":"_1F2S8J_RjbqfTiD12AbfZG","icon":"S8xnISb_sf6bOq5jQryOG","saveBtn":"_39p_ZDdGlwFTaav2hqfYeY"};